// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: shared/api/common/ENUM_PropertyInvestmentType.proto

export enum ENUM_PropertyInvestmentType {
  PROPERTY_INVESTMENT_TYPE_UNSPECIFIED = 'PROPERTY_INVESTMENT_TYPE_UNSPECIFIED',
  PROPERTY_INVESTMENT_TYPE_RESIDENTIAL = 'PROPERTY_INVESTMENT_TYPE_RESIDENTIAL',
  PROPERTY_INVESTMENT_TYPE_BUY_TO_LET = 'PROPERTY_INVESTMENT_TYPE_BUY_TO_LET',
  UNRECOGNIZED = 'UNRECOGNIZED',
}
